import * as React from 'react';

import { translate } from '~l10n/client';

import { ExportFeedback } from './ExportFeedback';
import { Drive } from './ExportFeedbackIcons';

const ExportFeedbackSaveToDriveComplete = ({
  onBack,
}: {
  onBack: () => void;
}) => (
  <ExportFeedback
    onBack={onBack}
    icon={<Drive />}
    title={translate('Saving')}
    message={translate(
      'The results will be added to your Google Drive shortly.'
    )}
  />
);

export { ExportFeedbackSaveToDriveComplete };
